import 'css-chunksrc/client/scenes/workloads/wbs/styles.scss';export default {
  "elementCreationForm": "_elementCreationForm_jpy1j_1",
  "draggable": "_draggable_jpy1j_10",
  "placeholder": "_placeholder_jpy1j_14",
  "load": "_load_jpy1j_1"
};